import {
  Text,
  Secondary,
  Stack,
  Inline,
  InlineItem,
  UtilityButton,
  Content,
} from '@kinesis/bungle';
import { noop } from 'lodash/fp';
import { AccessKeyItem } from './access-key-item';
import { AccessKeyConfirmation } from './access-key-confirmation';
import { AccessKey, AccessKeySecret } from '@/types';
import { Layout } from '@/components/layout';

const AccessKeys = (props: AccessKeysProps) => {
  const {
    keys = [],
    now,
    onNewAccessKey = noop,
    onDeleteAccessKey = noop,
    onClickAccessKey,
    isCreating = false,
    newAccessKey,
    onDismissNewAccessKey = noop,
  } = props;
  return (
    <Layout variant='narrow'>
      <Content>
        {newAccessKey && (
          <AccessKeyConfirmation
            onDismissNewKey={onDismissNewAccessKey}
            accessKey={newAccessKey}
          />
        )}
        <Stack space='medium'>
          <Text>
            Access keys allow you to access Kinesis using our API. Your access
            keys are associated with your account and inherit your permissions.
          </Text>
          {keys.length === 0 ? (
            <Stack space='small'>
              <Text>
                <Secondary>
                  Create an access key to authenticate with the Kinesis API from
                  data integrations, data lakes, or AI tools.
                </Secondary>
              </Text>
              <Inline>
                <InlineItem>
                  <UtilityButton
                    icon='plus'
                    onClick={onNewAccessKey}
                    disabled={isCreating}
                    magnitude='small'
                    variant='accent'
                  >
                    Generate your first access key
                  </UtilityButton>
                </InlineItem>
              </Inline>
            </Stack>
          ) : (
            <>
              <Stack space='small'>
                {keys.map((key) => (
                  <AccessKeyItem
                    key={key.id}
                    id={key.id}
                    name={key.name}
                    created={key.created}
                    lastUsed={key.lastUsed}
                    expiresAt={key.expiresAt}
                    scopes={key.scopes}
                    now={now}
                    onClick={onClickAccessKey}
                    onDelete={onDeleteAccessKey}
                  />
                ))}
              </Stack>
              <Inline>
                <InlineItem>
                  <UtilityButton
                    icon='plus'
                    onClick={onNewAccessKey}
                    disabled={isCreating}
                    magnitude='small'
                  >
                    Generate access key
                  </UtilityButton>
                </InlineItem>
              </Inline>
            </>
          )}
        </Stack>
      </Content>
    </Layout>
  );
};

type AccessKeysProps = {
  keys?: AccessKey[];
  now: string;
  isCreating?: boolean;
  newAccessKey?: AccessKeySecret;
  onNewAccessKey?: () => void;
  onDeleteAccessKey?: (id: string) => void;
  onClickAccessKey?: (id: string) => void;
  onDismissNewAccessKey?: () => void;
};

export { AccessKeys };
